import createPageAndUpdateRoute from '../createPageAndUpdateRoute';
import getDashedTitle from '@/utilities/getDashedTitle';
import isFavourite from '@/utilities/favourites/isFavourite';

export default {
  mixins: [createPageAndUpdateRoute],

  data() {
    return {
      pageForUpdate: {
        id: '',
        title: '',
        content: '',
      },
      debounceContent: null,
      debounceTitle: null,
    };
  },

  methods: {
    onUpdate(value, pageId) {
      if (
        this.$route.name === 'newpage' &&
        !this.pageCreating /* && value !== this.$constants.emptyMarkdownInput */
      ) {
        this.createPageAndUpdateRoute().then((page) => {
          // focus editor after page creation
          // this.$refs.editor?.focusEditor?.('end');
        });
        return;
      }
    },

    setPageCreatingWatcher(content = true) {
      this.pageCreatingWatcher = this.$watch('pageCreating', () => {
        if (content) {
          this.debounnceUpdateContent();
        } else {
          this.debounnceUpdateTitle();
        }
        this.pageCreatingWatcher();
      });
    },

    debounnceUpdateContent() {
      clearTimeout(this.debounceContent);
      const { id, content } = this.page;
      this.pageForUpdate.id = id;
      this.pageForUpdate.content = content;
      if (!id) return;

      this.debounceContent = setTimeout(() => {
        this.updatePage({
          pageId: id,
          payload: {
            content,
          },
        });
        clearTimeout(this.debounceContent);
        this.debounceContent = null;
      }, 1000);
    },

    debounnceUpdateTitle() {
      clearTimeout(this.debounceTitle);
      const { title, id } = this.page;
      this.pageForUpdate.id = id;
      this.pageForUpdate.title = title;
      if (!id) return;

      this.debounceTitle = setTimeout(() => {
        this.updatePage({
          pageId: id,
          payload: {
            title,
          },
          updateRoute: !this.isInbox,
        });
        clearTimeout(this.debounceTitle);
        this.debounceTitle = null;
      }, 1000);
    },

    updatePage({ pageId, payload, updateRoute = true }) {
      return this.$store
        .dispatch('debounceUpdatePage', {
          pageId,
          payload,
        })
        .then((resp) => {
          if (payload.title && updateRoute) {
            // update title in route
            const dashedTitle = `-${getDashedTitle(payload.title)}`;
            if (dashedTitle === this.$route.params.pageTitle) return resp;
            this.$router.replace({ params: { pageTitle: dashedTitle } });
          }
          return resp;
        })
        .catch(() => {
          // handle failed patch requests
        });
    },

    updatePageProp(propertyName, value) {
      this.$store.dispatch('localUpdatePageProp', {
        pageId: this.page.id,
        propertyName,
        value,
      });

      const payload = { [propertyName]: value };

      this.updatePage({
        pageId: this.page.id,
        payload,
      });
    },

    clearDebounceTimeout() {
      const { id } = this.page;
      if (!id) return;
      if (this.debounceContent) {
        clearTimeout(this.debounceContent);
        this.updatePage({
          pageId: this.pageForUpdate.id,
          payload: {
            content: this.pageForUpdate.content,
          },
        });
      }
      if (this.debounceTitle) {
        clearTimeout(this.debounceTitle);
        this.$store.dispatch('localUpdatePageProp', {
          pageId: this.pageForUpdate.id,
          propertyName: 'title',
          value: this.pageForUpdate.title,
        });
        this.updatePage({
          pageId: this.pageForUpdate.id,
          payload: {
            title: this.pageForUpdate.title,
          },
          updateRoute: false,
        });
      }
    },

    updatePageTitle(value) {
      this.$store.dispatch('localUpdatePageProp', {
        pageId: this.page.id,
        propertyName: 'title',
        value,
      });
      if (this.$route.name === 'newpage' && !this.pageCreating) {
        this.createPageAndUpdateRoute(true);
        return;
      }
      if (this.pageCreating) {
        this.setPageCreatingWatcher(false);
        return;
      }
      if (isFavourite(this.page.id, 'page')) {
        this.$store.dispatch('localUpdateResourceInFavourites', {
          resource_id: this.page.id,
          resource_type: 'page',
          title: value,
        });
      }
      this.debounnceUpdateTitle();
    },
  },

  unmounted() {
    this.clearDebounceTimeout();
  },
};
